<template>
  <div class="whole">
    <div class="search">
      <el-form :inline="true">
        <el-form-item>
          <el-cascader
              clearable
              filterable
              collapse-tags
              :placeholder="$t('placeholder.City')"
              :props="{multiple: true}"
              :options="optionsCity"
              v-model="valueCity"
              style="width: 250px"
              :disabled="disableButton"
          ></el-cascader>
        </el-form-item>

        <el-form-item>
          <el-select v-if="isOk" v-model="valueIndex" :placeholder="$t('placeholder.Index2')" style="width: 250px" :disabled="disableButton">
            <el-option
                v-for="item in optionsIndex"
                :key="item.id"
                :label="item.name_cn"
                :value="item.name_cn">
            </el-option>
          </el-select>

          <el-select v-if="!isOk" v-model="valueIndex" :placeholder="$t('placeholder.Index2')" style="width: 250px" :disabled="disableButton">
            <el-option
                v-for="item in optionsIndex"
                :key="item.id"
                :label="item.name_en"
                :value="item.name_en">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item>
          <el-select v-model="valueYear" multiple collapse-tags clearable filterable :placeholder="$t('placeholder.Year3')" @change="changeYear(valueYear)">
            <el-option
                v-for="item in optionsYear"
                :key="item.value"
                :label="item.label"
                :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="changeSearch(valueCity,valueIndex)" :disabled="disableButton">{{ $t("button.Search") }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--  图表  -->
    <div class="containerChart">
      <div id="eChart"></div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "changeDataSearch",
  data(){
    return{
      isOk:'',
      disableButton:true,
      valueYear:[],
      optionsYear:[],
      optionsCity: [],//"城市"下拉列表
      optionsIndex: [],//"指标"下拉列表
      valueCity:[],//选中的城市列表
      valueIndex:'',//选中的指标值
      // yearData:['2006','2007','2008','2009','2010','2011','2012','2013','2014','2015','2016','2017','2018','2019'],//图表x轴坐标
      yearData:[],
      seriesData:[],//动态生成的表格数据
      colorOption:['orange','red','green','blue','purple'],//表格颜色列表
    }
  },
  methods:{
    changeYear(valueYear){
      valueYear.sort(this.descOrder)
      this.yearData=valueYear
    },
    descOrder:function (a,b){
      return a-b;
    },
    //获取选择框中选择的数据
    async changeSearch(valueCity,valueIndex){
      if(this.yearData===''){
        if(this.isOk===true){alert("请选择查询年份！")}
        else{("Please choice search year!")}
      }
      var that=this
      var fflag=false
      that.seriesData=[]
      //循环遍历所有选中的城市
      for(let i=0;i<valueCity.length;i++){
        var city=valueCity[i]
        await request.get('/dataAnalysis/varationTrend?city_id='+city[2]+'&name_'+that.$i18n.locale+'='+valueIndex).then(result => {
          var dataWhole=[]
          var tempData=[]
          var tempSeries={
            data:'',
            type: 'line',
            name:'',
            symbol: 'circle',
            symbolSize: 10,
            connectNulls: true,
            lineStyle: {
              color: '#5470C6',
              width: 3,
              type: 'dashed'
            },
            itemStyle: {
              borderWidth: 5,
              borderColor: that.colorOption[i%5],
              color: 'yellow'
            }
          }
          //用dataWhole临时存储不同年份这个城市指标的所有指标
          dataWhole= result.data
          //因为每一年只有一个数值，所以遍历所有年份，去查找dataWhole里面有没有这个年份的数据，如果没有，这个年份的值就是null
          for(let i=0;i<this.yearData.length;i++){
            let flag1= dataWhole.findIndex(item => item.eva_index.year === parseInt(this.yearData[i]))
            if(flag1!==-1){
              tempData.push(dataWhole[flag1].score)
            }
            else{
              tempData.push(null)
            }
          }
          //这条线的名字就是这个城市
          if(that.$i18n.locale==='cn'){
            tempSeries.name=result.data[0].city.name_cn
          }
          else{
            tempSeries.name=result.data[0].city.name_en
          }
          tempSeries.data=tempData
          //把这条线放在seriesData中（因为如果选中许多城市，就会有许多条线）
          that.seriesData.push(tempSeries)
          for(let i=0;i<tempSeries.data.length;i++){
            if(tempSeries.data[i]!=null){
              fflag=true
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }
      if(fflag===true){
        this.getLoadEcharts();
      }
      else{
        if(that.isOk===true){
          alert("没有数据，请重新选择")
          this.valueYear=''
          this.valueCity=''
          this.valueIndex=''
        }
        else{
          alert("There are no data, please select again!")
          this.valueYear=''
          this.valueCity=''
          this.valueIndex=''
        }
      }
    },
    //加载图表
    getLoadEcharts() {
      var myChart = this.$echarts.init(document.getElementById("eChart"));

      var option = {
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross'
          }
        },
        xAxis: {
          type: 'category',
          name:'年份-Year',
          data: this.yearData
        },
        yAxis: {
          type: 'value',
          name:'指标分数-Score'
        },
        series:this.seriesData
      };
      myChart.setOption(option);
    },
    //获取城市数据---级联选择器
    getCitys(){
      var that=this
      var continent={}
      var country={}
      var city={}
      request.get('/continent').then(async function (res){
        for(let i=0;i<res.data.length;i++){
          let continentItem=res.data[i]
          continent={
            label:'',
            value:'',
            children:[]
          }
          if(that.$i18n.locale==='cn'){
            continent.label=continentItem.name_cn
          }
          else{
            continent.label=continentItem.name_en
          }
          continent.value=continentItem.id

          //根据洲id获取国家，存在临时country字典中，并push到continent的children列表中
          await request.get('/country?continent_id='+continentItem.id).then(async function (res1){
            for(let j=0;j<res1.data.length;j++){
              let countryItem=res1.data[j]
              country={
                label:'',
                value:'',
                children:[]
              }
              if(that.$i18n.locale==='cn'){
                country.label=countryItem.name_cn
              }
              else{
                country.label=countryItem.name_en
              }
              country.value=countryItem.id
              //根据国家id获取城市，存在临时city字典中，并push到country的children列表中
              await request.get('city?country_id='+countryItem.id).then(function (res2){
                for(let k=0;k<res2.data.length;k++){
                  let cityItem=res2.data[k]
                  city={
                    label:'',
                    value:'',
                  }
                  if(that.$i18n.locale==='cn'){
                    city.label=cityItem.name_cn
                  }
                  else{
                    city.label=cityItem.name_en
                  }
                  city.value=cityItem.id
                  country.children.push(city)
                }
                continent.children.push(country)
              }).catch(function (err2){
                console.log(err2)
              })
            }
          }).catch(function (err1){
            console.log(err1)
          })
          that.optionsCity.push(continent)
        }
      }).catch(function (err){
        console.log(err)
      })
    },
    //获取指标
    getIndex(){
      request.get('/EvaIndex').then(result => {
        const map = new Map()
        if(this.$i18n.locale==='cn'){
          const newData = result.data.filter(key => !map.has(key.name_cn) && map.set(key.name_cn, 1)) // 这里对name属性进行去重
          this.optionsIndex = newData
        }
        else{
          const newData = result.data.filter(key => !map.has(key.name_en) && map.set(key.name_en, 1)) // 这里对name属性进行去重
          this.optionsIndex = newData
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getUser(){
      var roleTemp=''
      var that=this
      request.get('/sysUser/currentUser').then(function(res){
        for(let i=0;i<res.data.roles.length;i++){
          if(res.data.roles[i].id===5){
            roleTemp=5
          }
        }
        if(roleTemp===5){
          that.disableButton=false
        }
        else{
          if(that.$i18n.locale==='cn'){
            alert("只有正式会员才可以使用该模块！")
          }
          else{
            alert("Only full members can use this module!")
          }
        }
      }).catch(function (err){
        console.log(err)
      })
    }
  },
  //在页面创建时，获取城市和指标的列表
  mounted() {
    this.getCitys()
    this.getIndex()
    this.getUser()
    this.optionsYear= JSON.parse(window.sessionStorage.getItem('years'))
  },
  created() {
    if(this.$i18n.locale==='cn'){
      this.isOk=true
    }
    else{
      this.isOk=false
    }
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
#eChart{
  width: 850px;
  height: 550px;
}
.containerChart{
  margin-left: 100px;
}
</style>